import type {FC} from 'react';
import {
  Button,
  IconButton,
  IconNames,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
} from '@wellstone-solutions/web';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  text: string;
  buttonLabel?: string;
  onClose: (open: boolean) => void;
  onConfirm: () => void;
  loading?: boolean;
}

const DEFAULT_LABEL = 'Confirm';

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  open,
  title,
  text,
  buttonLabel = DEFAULT_LABEL,
  onClose,
  onConfirm,
  loading = false,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center">
          {title}
          <IconButton onClick={onClose} icon={IconNames.Xmark} />
        </Stack>
      </DialogTitle>

      <DialogContent>{text}</DialogContent>

      <DialogActions sx={{p: 3, pt: 1}}>
        <Button
          variant="text"
          onClick={() => onClose(false)}
          disabled={loading}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={loading}>
          {buttonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
